export enum ChallengeActivityTypesEnum {
	Running = 'running',
	Workout = 'workout',
	Rest = 'rest',
}
